import { render, staticRenderFns } from "./preview-summary-row.vue?vue&type=template&id=b12d23f8&scoped=true"
import script from "./preview-summary-row.vue?vue&type=script&lang=js"
export * from "./preview-summary-row.vue?vue&type=script&lang=js"
import style0 from "./preview-summary-row.vue?vue&type=style&index=0&id=b12d23f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12d23f8",
  null
  
)

export default component.exports